export class EventEmitter {
    constructor() {
        this.events = new Map();
    }
    emit(event, msg) {
        const listeners = this.events.get(event) || [];
        for (let i = listeners.length - 1; i >= 0; i--) {
            const listener = listeners[i];
            listener.cb(msg);
            if (listener.once) {
                listeners.splice(i, 1);
            }
        }
    }
    emitAsync(event, msg) {
        const listeners = this.events.get(event) || [];
        setTimeout(() => {
            for (let i = listeners.length - 1; i >= 0; i--) {
                const listener = listeners[i];
                listener.cb(msg);
                if (listener.once) {
                    listeners.splice(i, 1);
                }
            }
        });
    }
    on(event, cb) {
        this.addListener(event, cb, false);
    }
    once(event, cb) {
        this.addListener(event, cb, true);
    }
    addListener(event, cb, once) {
        const listeners = this.events.get(event) || [];
        listeners.push({
            once,
            cb,
        });
        this.events.set(event, listeners);
    }
}
//# sourceMappingURL=index.js.map